import { useContext } from 'react'
import { PageContext } from '@contexts'

const usePageContext = () => useContext(PageContext)

export default usePageContext
